import { Component, OnInit } from '@angular/core';
import { FnToasterService, FnModalService, FnUtilService, FnTableConfig, TableAction, FnTableMetaData, TABLE_ACTION_TYPE } from 'foundation';
import { Subject } from 'rxjs';
import { EOAlertDisableSetup} from '../../../modal/entity.modal';
import { PosHttpService } from '../../../services/pos.http.service';
import { AlertDisableModelComponent } from './alert-disable-model/alert-disable-model.component';

@Component({
  selector: 'app-alert-disable',
  templateUrl: './alert-disable.component.html',
  styleUrl: './alert-disable.component.scss'
})
export class AlertDisableComponent implements OnInit {
  constructor(private posHttpSvcs: PosHttpService, private toastr: FnToasterService, private fnModalSvcs: FnModalService, private fnutilservice: FnUtilService, private toaster: FnToasterService) {

  }
  ngOnInit(): void {
    this.loadData();
  }

  uiMap = {
    isDataLoaded: false,
  };
  showData = false;

  config: FnTableConfig = {
    uniqueKey: 'primaryKey',
    defaultSortKey: 'primaryKey',
    tableAction: new Subject<TableAction>(),
    hideAction: true
  };

  rowMetaArray: FnTableMetaData[] = [
    {
      key: 'primaryKey',
      description: 'Primary Key',
      isHidden: true,
      isSortable: true,
      type: 'number',
    },
    {
      key: 'database',
      description: 'Database',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'schema',
      description: 'Schema',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'server',
      description: 'Server',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'appInstance',
      description: 'App Instance',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'dirPath',
      description: 'Dir Path',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'whereClause',
      description: 'where Clause',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'isActive',
      description: 'isActive',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'isGlobal',
      description: 'isGlobal',
      type: 'string',
      isSortable: true,
    }
  ];

  alertDisableArray: EOAlertDisableSetup[] = [];


  loadData() {
    this.posHttpSvcs.authGet('v1/ui/loadAlertDisableData', 'loadAlertDisableData').subscribe((resp: any) => {
      if (resp.isError) {
        this.toastr.error('Invalid loadAlertDisableData ⚠️');
        return;

      }
      this.alertDisableArray = resp.data;
      this.showData = false;
		    this.refreshTableData();
			this.uiMap.isDataLoaded = true;
    });
  }
  updateRowAction(event: EOAlertDisableSetup) {
    const AlertDisableModal = this.fnModalSvcs.openCustomModal(AlertDisableModelComponent, {
    data: {
      EOAlertDisableSetup: event
    },
    hasBackdrop: true,
    width: '500px',
  })
  AlertDisableModal.afterClosed().subscribe((objectHash) => {
    if(objectHash != undefined){
    this.addUpdateEOAlertDisable(objectHash);
    }
  });
}
deleteRowAction(event: EOAlertDisableSetup) {
  const dialogRef = this.fnModalSvcs.openConfirmModal({
    isConformationMdl: true,
    content: 'Are you sure you want to delete ?',
    type: 'danger',
  });
  dialogRef.afterClosed().subscribe(doAction => {
    if (doAction) {
      this.posHttpSvcs.authDeleteWithBody('v1/ui/deleteAlertDisableSetup', event.primaryKey, event).subscribe(resp => {
        this.loadData();
      })
    }
  });

}

openActionMdl() {
  const alertDisableModal = this.fnModalSvcs.openCustomModal(AlertDisableModelComponent, {
    data: {
    },
      hasBackdrop: true,
      width: '500px',
  })
  alertDisableModal.afterClosed().subscribe((objectHash) => {
    this.addUpdateEOAlertDisable(objectHash);
  });
}

addUpdateEOAlertDisable(objectHash: any) {
  this.posHttpSvcs.authPut('v1/ui/saveAlertDisableSetup', 'saveAlertDisableSetup', objectHash).subscribe(resp => {
    if (resp.isError) {
      this.toastr.error(' AlertDisabled is not added ⚠️');
      return;
    } else {
      this.toastr.success("added successfully");
      this.loadData();
    }
  })

}

refreshTableData() {
  if (this.config.tableAction.closed) {
    this.config.tableAction = new Subject<TableAction>();
  }
  this.config.tableAction.next({
    data: this.alertDisableArray,
    action: TABLE_ACTION_TYPE.REFRESH,
  });
}
}
